// ─── EscContentCreatorPro v149 — Slim Orchestrator (UI-only) ───────────────────────────
// Phase 10: Thin wiring layer — delegates all logic to hooks and all UI to steps.
// [ARCH-v132] BE-served tenant logo + favicon; removed dead header block and showHeader prop.
// [ARCH-v133] Migrate tone to backend's new tone_hint field
//   - Drop tone_overrides; send top-level tone_hint: string | null instead
//   - brand-voice sent as literal (distinct from null per backend semantics)
//   - Regenerate-from-entry restores historical tone via toneStateFromParams
//   - New shared helper: src/utils/toneMigration.js
// [FEAT-v134] Step1 UX rifinitura — TASK→ARGOMENTO/TEMA/SOGGETTO; FOCUS+KEY POINTS riordinati e
//   rinominati in PUNTI CHIAVE (prima) + CONTESTO E ANGOLO (dopo); TUTTI i tooltip ⓘ
//   sostituiti da HelperLine sempre visibili (incluse PERSONA/OBIETTIVO/TONE/MODALITÀ
//   CONTENUTO/PARAMETRI MODALITÀ); rinomina sub-blocchi Ricerca (DOCUMENTI CARICATI, URL DI
//   RIFERIMENTO, RICERCA WEB); placeholder uniformati; dead-code IIFE "Suggerisci" e
//   componente Tooltip rimossi da Step1Setup. [ZERO-BREAK] pipeline e contract backend
//   invariati.
// [FEAT-v135] Examples Library Phase 1 integration — terzo bottone "Vedi esempi compilati"
//   in Step1Setup (gated dal content_format risolto), ExamplesPanel inline che fetcha
//   GET /api/v1/examples?tenant=…&content_format=… (lista con BriefEnvelope inlined per
//   item → hover-preview e load-on-click serviti da una sola round-trip), helper
//   briefEnvelopeToFormState che inverte resolvePlatformAndFormat e delega a
//   paramsToFormState. [ZERO-BREAK] pipeline invariata.
// [FEAT-v136] Blog-SEO keywords structured schema — split single "Keywords SEO" input
//   into "Keyword principale" + dynamic list of "Keyword secondarie" rows with optional
//   per-row vol/mese (cap 8, default 3 empty rows). New helpers serializeKeywords
//   (backendClient) + deserializeKeywords (paramsToFormState, accepts both new object
//   and legacy comma-string for backward-compat with stale localStorage). Export
//   formatter useHistory.collectInputRows special-cases the new shape so MD/PDF/DOCX
//   downloads render "primary; secondary (vol/mese); …" instead of [object Object].
//   State default DEFAULT_BLOG_PARAMS.keywords becomes {primary, secondary[]}.
//   [ZERO-BREAK] BE accepts both shapes during rollout; pipeline, prompts, and output
//   renderers unchanged.
// [FEAT-v137] Gestione Run admin section — new /admin/runs (list) and /admin/runs/:taskId
//   (detail) pages, gated by RequireSuperadmin. List view supports tenant selection (SA),
//   status chip filter, date range (default last 7 days, EXCLUSIVE upper bound), and
//   secondary filters (user/platform/content_format). Detail view fetches /status +
//   /content in parallel, renders metadata + result/research/reviews/sources panels via
//   JsonBlock, plus a Langfuse trace deep link (REACT_APP_LANGFUSE_URL). Back-button
//   preserves list filters via location.state.from.
// [FEAT-v137] apiFetch.suppressTenantHeader — new option that skips the X-Tenant-Id
//   header injection. Used by the admin runs API client so an explicit ?tenant= query
//   param always wins over any stale tenant context cached in localStorage.
// [FEAT-v138] Tenant-admin console — new /tenant-admin/users route (gated by RequireTenantAdmin)
//   lets users with user_tenants.role='admin' manage members of their active tenant: list (with
//   email filter + pagination), atomic create (POST /api/v1/tenant-admin/users with 409→attach
//   fallback), inline role select, deactivate (with USER_HAS_OTHER_TENANTS surfacing), and remove
//   from tenant via ConfirmDialog. New isTenantAdmin derived boolean on AuthContext. Separate BE
//   router /api/v1/tenant-admin/* — not piggybacking on /admin/*. SA actions and the detail page
//   (email/password edit, activate, GET-by-id) intentionally omitted pending BE additions.
//   [ZERO-BREAK] pipeline, prompts, and content-generator UX unchanged.
// [FEAT-v139] Landing input parameters wired end-to-end (GitLab issue "Input parameters
//   per 'Landing' mancanti"). resolvePlatformAndFormat now emits content_format:'landing'
//   (fixed). buildContentParams gains a landing case → headline_formula (always) +
//   social_proof (trimmed, omitted when blank). Step1Setup: landing removed from the
//   SPECIFICHE TECNICHE exclusion → new "Formula Headline" Sel (LANDING_HEADLINE_OPTIONS)
//   + "Social Proof (opzionale)" textarea; CTA testo/URL CTA inputs now also shown for
//   landing (intended). paramsToFormState reconstructs landingParams on run reload.
//   [ZERO-BREAK] pipeline, prompts, and output rendering unchanged (formatters switch on
//   mode, not content_format).
// [FEAT-v140] Cancel running pipeline: POST /pipeline/run/{id}/cancel (soft-cancel).
//   New cancelGeneration() in useGeneration; 'cancelled' terminal status → cancelled
//   history entry (no content); two-step confirm button in Step2Generate (pipeline
//   stepper only, not Suggerisci); PipelineStepper isCancelled state; styling = 409
//   non-cancellable. [ZERO-BREAK] for completed/failed paths and output rendering.
// [FEAT-v141] Instagram-post dedicated renderer: new InstagramResultEntry covers
//   QA bar, "anteprima feed" hook box, body paragraphs, CTA highlight, hashtag
//   chips (caption-placed 2-4), non-clickable "Link in bio" pointer for cta_url,
//   character-count budget bar (5 tiers up to ≤2200 IG hard cap), and FONTI
//   CITATE via SourcesCitedBlock. Dispatched in renderResultEntry by
//   r.platform === 'instagram' (content_format='post' is shared across
//   linkedin/facebook/instagram so platform is the discriminator). [ZERO-BREAK]
//   pipeline, prompts, formatters, and other variant renderers unchanged.
// [FEAT-v142] Landing-page dedicated renderer: new LandingResultEntry consumes
//   the structured content_format='landing' shape (7 blocks: HERO, PROBLEM,
//   SOLUTION, FEATURES, SOCIAL_PROOF, FAQ, FINAL_CTA + FONTI CITATE). Adds QA
//   bar (qa_score → style_compliance fallback), fixed Italian anchor IDs
//   (#hero, #problema, #soluzione, #caratteristiche, #social-proof, #faq,
//   #cta-finale), inline-HTML sanitization via sanitizeHtml, single
//   source-of-truth CTA URL (content.cta_url, disabled buttons when empty),
//   green HERO + FINAL_CTA CTA buttons, optional-block hide rules
//   (features.items/social_proof.bullets/faq empty → entire section hidden).
//   Dispatched in renderResultEntry by r.contentFormat === 'landing'.
//   Landing warnings (LANDING_REQUIRED_BLOCK_EMPTY,
//   LANDING_OPERATOR_SOCIAL_PROOF_DROPPED) get friendly Italian copy via the
//   existing outer chrome WarningBanner — extended in friendlyWarningCopy
//   (Step3History.jsx) with a consolidation helper that collapses multiple
//   per-field required-block warnings into one banner. Replaces a 22-line
//   dead stub that read a stale (pre-spec) field shape and was never wired
//   into the dispatcher. [ZERO-BREAK] pipeline, prompts, formatters, and
//   other variant renderers unchanged.
// [FEAT-v145] Pinterest-post dedicated renderer: new PinterestResultEntry
//   consumes the Path B typed shape (docs/frontend/pinterest-post-rendering.md
//   — pin_title, pin_description, board_suggestion, hashtags, cta_url,
//   full_text). Covers QA bar, bold pin title, plain description, "Board
//   consigliato:" line with bookmark icon, hashtag chips, destination
//   URL link, character-count budget bar (4 tiers up to ≤500 hard cap),
//   and FONTI CITATE via SourcesCitedBlock. Dispatched in
//   renderResultEntry by r.platform === 'pinterest'. Replaces the broken
//   fallback path that previously rendered Pinterest runs through the
//   generic structured branch (which reads empty hook/body/cta for the
//   Path B shape and shows nothing). [ZERO-BREAK] pipeline, prompts,
//   formatters, and other variant renderers unchanged.
// [FEAT-v144] YouTube long-form dedicated renderer: rewrites the stale
//   YouTubeResultEntry to consume the documented spec shape
//   (docs/frontend/youtube-post-rendering.md). Covers QA bar, bold title,
//   ALT 1/2 chips for title_variants, HOOK DESCRIZIONE pink-bordered box,
//   description prose (no label), CAPITOLI two-column block, TAG VIDEO
//   chips, THUMBNAIL + CTA SCRIPT side-by-side, SEO KEYWORDS 3-tier
//   (primary highlighted / secondary plain / long_tail italic-dashed),
//   hashtag chips, and FONTI CITATE via SourcesCitedBlock. Wired into
//   renderResultEntry by r.platform === 'youtube' — previously the
//   component was dead code (defined but never imported). [ZERO-BREAK]
//   pipeline, prompts, formatters, and other variant renderers unchanged.
// [FEAT-v143] Renderer label alignment + Facebook-post dedicated renderer:
//   (1) SourcesCitedBlock heading renamed globally from "PRINCIPALI FONTI DA
//   INCLUDERE" to "FONTI CITATE" (shared by Instagram/Newsletter/Landing).
//   (2) InstagramResultEntry hashtag block label renamed to "PRIMO COMMENTO
//   — HASHTAG (N)" to reflect IG first-comment best practice (channels.js
//   policy: "20-30 hashtag (nel primo commento)"). (3) New
//   FacebookResultEntry covers QA bar, hook box (FB blue), body paragraphs,
//   CTA highlight, hashtag chips (0-2 per channels.js policy), and FONTI
//   CITATE via SourcesCitedBlock. Dispatched in renderResultEntry by
//   r.platform === 'facebook'. [ZERO-BREAK] pipeline, prompts, formatters,
//   and other variant renderers unchanged.
// [FEAT-v146] Run Detail v2 — unified GET /pipeline/run/{id} fetch, full
//   brief + result rendering on /admin/runs/:taskId and /tenant-admin/runs/:taskId.
//   New: BriefPreview (extracted from ExamplesPanel), renderResultEntry (extracted
//   from this file), Disclosure-collapsible drafts/reviews/style/research/sources,
//   light theme constants, and tenant-admin "Ricarica nel Content Generator"
//   button that hands off brief_json + synthetic history entry via
//   location.state so the form pre-populates AND the output appears in History
//   without re-running the pipeline. [ZERO-BREAK] pipeline, prompts, output
//   renderers, and SA/TA gating semantics unchanged.
// [FEAT-v147] Dashboard reorganized into 3 narrative sections (Utilizzo & adozione /
//   Salute della pipeline / Qualità & efficienza). ChartCard gains a per-card
//   reliability badge (green "Tutto il periodo" vs amber "Campione: ultimi N");
//   replaces the inline withSampleDisclosure title suffix. Presentation-only —
//   no data fetching, chart math, or component internals changed. [ZERO-BREAK]
// [FEAT-v148] Tenant Credits dashboard — new /credits route (sections/Credits.jsx)
//   with a balance gauge (CreditBalanceCard, has-plan vs no-plan/untracked) and
//   per-user usage table (CreditUsageTable; email folds to short id for members,
//   $ column superadmin-only). New services/api/creditsApi.js (GET /credits/balance
//   + /credits/usage?group_by=user) + utils/creditsFormat.js (Decimal-string
//   parsing, it-IT credit formatting, USD, Rome-month label). Superadmin plan
//   settings: /admin/plans tab (PlanListPage + PlanModal CRUD) and per-tenant
//   balance/$ spend/subscription assignment on the tenant detail
//   (TenantCreditsSection in TenantManagementPage), backed by new adminApi plan/
//   subscription calls. Display-only — nothing gates a run on balance. [ZERO-BREAK]
//   content pipeline, prompts, and renderers untouched.
// [FEAT-v149] Storico Generazioni for plain members — new member-facing /runs (list)
//   and /runs/:taskId (detail) routes, ungated beyond AppShell auth. Reuses
//   TenantRunListPage + RunDetailPage (now path-aware: row-click/back paths derive
//   from location.pathname instead of a hardcoded /tenant-admin/ prefix). Sidebar
//   gains a "Storico Generazioni" entry for non-SA, non-tenant-admin users
//   (tenant-admins/SAs keep their console entries — no duplicate). FE-only: BE
//   /pipeline/runs is already tenant-scoped (not admin-only) and nulls creator PII
//   for non-admins, so members see the full tenant set and can "Ricarica nel
//   Content Generator" (button already gated !isSuperadmin && brief_json).
//   [ZERO-BREAK] content pipeline, prompts, and renderers untouched.
// Target: ~200 lines.

import React, { useReducer, useRef, useEffect, useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Store
import { appReducer }         from './store/reducer.js';
import { createInitialState } from './store/initialState.js';

// Hooks
import { useGeneration }    from './hooks/useGeneration.js';
import { useHistory }       from './hooks/useHistory.js';
import { useClipboard }      from './hooks/useClipboard.js';
import { useContextOptions } from './hooks/useContextOptions.js';

// Utils
import { briefEnvelopeToFormState } from './utils/briefEnvelopeToFormState.js';

// Step components
import Step1Setup    from './components/steps/Step1Setup.jsx';
import Step2Generate from './components/steps/Step2Generate.jsx';
import Step3History  from './components/steps/Step3History.jsx';
import Step4Publish  from './components/steps/Step4Publish.jsx';

import { getModeConfig, ESC_ACCENT } from './constants/modes.js';
import { SUGGEST_SLOTS, mapSuggestEvent } from './constants/pipelineSlots.js';
import { buildBriefRequest } from './services/api/backendClient.js';
import { streamSSE } from './services/api/sseClient.js';
import { API_V1, getAuthHeaders, getSessionHeaders } from './services/api/config.js';
import { getBundle } from './services/api/uploadClient.js';
import renderResultEntry from './components/outputs/renderResultEntry.jsx';
import ExamplesModal from './components/ui/ExamplesModal.jsx';

// ─── Error Modal ─────────────────────────────────────────────────────────────

const ErrorModal = ({ message, onClose, t }) => {
  if (!message) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: t.inputBg || '#1a1a2e', borderRadius: '16px',
          border: '1.5px solid rgba(239,68,68,0.4)',
          padding: '28px 28px 24px',
          maxWidth: '420px', width: '100%',
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
          <span style={{ fontSize: '20px' }}>⚠️</span>
          <span style={{ fontSize: '15px', fontWeight: 700, color: '#EF4444' }}>Errore</span>
        </div>
        <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: t.text, wordBreak: 'break-word' }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            marginTop: '20px', width: '100%', padding: '10px',
            borderRadius: '10px', border: '1px solid rgba(239,68,68,0.3)',
            background: 'rgba(239,68,68,0.08)', color: '#EF4444',
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Chiudi
        </button>
      </div>
    </div>
  );
};

// ─── Leave-guard Modal ──────────────────────────────────────────────────────

const LeaveGuardModal = ({ type, onConfirm, onCancel, t }) => (
  <div
    onClick={onCancel}
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: t.inputBg || '#1a1a2e', borderRadius: '16px',
        border: `1.5px solid rgba(245,158,11,0.4)`,
        padding: '28px 28px 24px',
        maxWidth: '420px', width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
        <span style={{ fontSize: '20px' }}>⚠️</span>
        <span style={{ fontSize: '15px', fontWeight: 700, color: '#F59E0B' }}>Output presente</span>
      </div>
      <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: t.text }}>
        {type === 'generate'
          ? 'Hai output generati che verranno sovrascritti dalla nuova generazione. Scarica i contenuti che vuoi conservare prima di procedere.'
          : 'Hai output generati che andranno persi. Scarica i contenuti che vuoi conservare prima di procedere.'}
      </p>
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button
          onClick={onCancel}
          style={{
            flex: 1, padding: '10px', borderRadius: '10px',
            border: `1px solid ${t.border || 'rgba(255,255,255,0.1)'}`,
            background: 'transparent', color: t.text,
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Resta qui
        </button>
        <button
          onClick={onConfirm}
          style={{
            flex: 1, padding: '10px', borderRadius: '10px',
            border: '1px solid rgba(245,158,11,0.3)',
            background: 'rgba(245,158,11,0.08)', color: '#F59E0B',
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Genera comunque
        </button>
      </div>
    </div>
  </div>
);

// ─── Main component ───────────────────────────────────────────────────────────

const EscContentCreatorPro = ({ tenantId = null }) => {
  const [state, dispatch] = useReducer(appReducer, null, createInitialState);
  const stateRef         = useRef(state);
  stateRef.current       = state;
  const contentMemoryRef = useRef([]);

  const { activeMode, isDarkMode, wizardStep } = state;

  // ── Theme ──────────────────────────────────────────────────────────────────
  const w = useCallback((opacity) =>
    isDarkMode
      ? `rgba(255,255,255,${opacity})`
      : `rgba(0,0,0,${Math.min(opacity * 2.5, 0.2).toFixed(2)})`
  , [isDarkMode]);

  const t = useMemo(() => isDarkMode
    ? { bg: 'linear-gradient(175deg, #08080d 0%, #0e0e18 40%, #0a0a12 100%)', text: '#e4e4ec', textSoft: '#c0c0d0', textMuted: '#7a7a8e', textFaint: '#555568', textDim: '#484858', surface: 'rgba(255,255,255,0.02)', border: 'rgba(255,255,255,0.07)', inputBg: 'rgba(255,255,255,0.04)', inputBorder: 'rgba(255,255,255,0.08)', btnText: '#0a0a0f' }
    : { bg: 'linear-gradient(175deg, #f5f5f7 0%, #ffffff 40%, #f5f5f7 100%)', text: '#1d1d1f', textSoft: '#1d1d1f', textMuted: '#3a3a3c', textFaint: '#6c6c6d', textDim: '#6c6c6d', surface: 'rgba(0,0,0,0.015)', border: 'rgba(0,0,0,0.10)', inputBg: '#ffffff', inputBorder: 'rgba(0,0,0,0.18)', btnText: '#ffffff' }
  , [isDarkMode]);

  const c = wizardStep === 1 ? ESC_ACCENT : (getModeConfig(activeMode)?.color || '#6366F1');

  // ── Hooks ──────────────────────────────────────────────────────────────────
  const { handleGenerate, regenerateFromEntry, cancelGeneration } =
    useGeneration({ dispatch, stateRef });

  const { deleteEntry, confirmOutput, getOutputText, getBlogHtml, exportEntry, downloadAs } =
    useHistory({ state, dispatch, contentMemoryRef });

  const { personaOptions, objectiveOptions } = useContextOptions();

  const { copy } = useClipboard({
    onSuccess: (id) => {
      dispatch({ type: 'SET_KEY', key: 'copiedId', value: id });
      setTimeout(() => dispatch({ type: 'SET_KEY', key: 'copiedId', value: null }), 2500);
    },
  });

  // Sync tenantId prop into reducer when mounted inside AppShell
  useEffect(() => {
    if (tenantId) dispatch({ type: 'SET_KEY', key: 'tenant', value: tenantId });
  }, [tenantId, dispatch]);

  // Fetch upload bundle on mount
  useEffect(() => {
    let cancelled = false;
    getBundle().then(bundle => {
      if (!cancelled) {
        const files = bundle.files || [];
        dispatch({ type: 'SET_UPLOAD_BUNDLE_FILES', files });
        if (files.length > 0) {
          dispatch({ type: 'SET_KEY', key: 'userKbEnabled', value: true });
        }
      }
    }).catch(() => {}); // 404 or error — treat as empty
    return () => { cancelled = true; };
  }, [dispatch]);

  const handleSuggest = useCallback(async () => {
    if (stateRef.current.suggestProgress) return;  // already running
    const s = stateRef.current;
    if (!s.taskText || s.taskText.trim().length < 10) {
      dispatch({ type: 'SET_KEY', key: 'error', value: 'Inserisci un task di almeno 10 caratteri' });
      return;
    }

    const timings = { setup: { startedAt: Date.now() } };
    let lastSlotId = 'setup';

    dispatch({ type: 'SET_BATCH', payload: {
      suggestProgress: {
        slots: SUGGEST_SLOTS,
        activePhase: mapSuggestEvent('starting'),
        isComplete: false,
        isError: false,
        errorMessage: null,
        slotTimings: { ...timings },
      },
      error: null,
    }});

    try {
      const briefRequest = buildBriefRequest(s);
      const requestBody = { ...briefRequest, language: 'it' };
      const tenant = s.tenant || 'alens';

      const result = await new Promise((resolve, reject) => {
        streamSSE({
          url: `${API_V1}/briefs/generate?tenant=${tenant}`,
          body: requestBody,
          headers: { ...getSessionHeaders(), ...getAuthHeaders() },
          onEvent: ({ data }) => {
            if (!data || typeof data !== 'object') return;

            if (data.type === 'complete') {
              resolve(data);
              return;
            }
            if (data.type === 'error') {
              reject(new Error(data.message || 'Errore generazione brief'));
              return;
            }

            // Map SSE event to stepper phase
            const phase = mapSuggestEvent(data.type);
            if (phase && phase.slotId !== lastSlotId) {
              const now = Date.now();
              if (timings[lastSlotId] && !timings[lastSlotId].endedAt) {
                timings[lastSlotId].endedAt = now;
              }
              timings[phase.slotId] = { startedAt: now };
              lastSlotId = phase.slotId;

              dispatch({ type: 'SET_KEY', key: 'suggestProgress', value: {
                slots: SUGGEST_SLOTS,
                activePhase: phase,
                isComplete: false,
                isError: false,
                errorMessage: null,
                slotTimings: { ...timings },
              }});
            }
          },
          onError: reject,
          onDone: resolve,
        });
      });

      // Close final timing
      if (timings[lastSlotId] && !timings[lastSlotId].endedAt) {
        timings[lastSlotId].endedAt = Date.now();
      }
      timings.done = { startedAt: Date.now(), endedAt: Date.now() };

      dispatch({ type: 'SET_KEY', key: 'suggestProgress', value: {
        slots: SUGGEST_SLOTS,
        activePhase: null,
        isComplete: true,
        isError: false,
        errorMessage: null,
        slotTimings: { ...timings },
      }});

      if (result && result.additional_context) {
        dispatch({ type: 'SET_KEY', key: 'focusTopic', value: result.additional_context });
      }
      if (result && result.key_points && result.key_points.length > 0) {
        dispatch({ type: 'SET_KEY', key: 'keyPoints', value: result.key_points.join('\n') });
      }
    } catch (err) {
      dispatch({ type: 'SET_KEY', key: 'suggestProgress', value: {
        slots: SUGGEST_SLOTS,
        activePhase: lastSlotId ? { slotId: lastSlotId, subLabel: '' } : null,
        isComplete: false,
        isError: true,
        errorMessage: err.message || 'Errore durante il suggerimento',
        slotTimings: { ...timings },
      }});
      dispatch({ type: 'SET_KEY', key: 'error', value: err.message || 'Errore durante il suggerimento' });
    } finally {
      setTimeout(() => dispatch({ type: 'SET_KEY', key: 'suggestProgress', value: null }), 3000);
    }
  }, [dispatch, stateRef]);

  // ── Shared renderer props ──────────────────────────────────────────────────
  const rendererProps = {
    copiedId: state.copiedId,
    onCopy: copy,
    w,
    t,
    onGetHtml: getBlogHtml,
  };

  const steps = ['Genera', 'Output'];

  const dismissError = useCallback(() => dispatch({ type: 'SET_KEY', key: 'error', value: null }), [dispatch]);

  // ── Track downloaded entries ────────────────────────────────────────────
  const downloadedIdsRef = useRef(new Set());

  const handleDownload = useCallback((entry, format) => {
    downloadAs(entry, format);
    downloadedIdsRef.current.add(entry.id);
  }, [downloadAs]);

  // ── Leave-guard: warn only if output hasn't been downloaded ──────────
  const [pendingAction, setPendingAction] = useState(null); // { action, type }

  const hasUndownloadedOutput = useCallback(() => {
    const history = stateRef.current.outputHistory || [];
    return history.length > 0 && history.some(e =>
      e.results?.status !== 'cancelled' && !downloadedIdsRef.current.has(e.id));
  }, [stateRef]);

  const guardedGenerate = useCallback(() => {
    if (hasUndownloadedOutput()) {
      setPendingAction({ action: () => { downloadedIdsRef.current.clear(); handleGenerate(); }, type: 'generate' });
    } else {
      downloadedIdsRef.current.clear();
      handleGenerate();
    }
  }, [hasUndownloadedOutput, handleGenerate]);

  const confirmAction = useCallback(() => {
    if (pendingAction) pendingAction.action();
    setPendingAction(null);
  }, [pendingAction]);

  const cancelAction = useCallback(() => setPendingAction(null), []);

  // ── Examples Library modal — opens via /content-generator#esempi ─────────
  const location = useLocation();
  const navigate = useNavigate();
  const examplesOpen = location.hash === '#esempi';
  const closeExamples = useCallback(() => {
    navigate(location.pathname + location.search, { replace: true });
  }, [navigate, location.pathname, location.search]);

  const handleLoadFromExample = useCallback((brief) => {
    const formState = briefEnvelopeToFormState(brief);
    dispatch({ type: 'SET_BATCH', payload: { ...formState, wizardStep: 1, error: null } });
    if (location.hash === '#esempi') {
      navigate(location.pathname + location.search, { replace: true });
    }
  }, [dispatch, navigate, location.pathname, location.search, location.hash]);

  // ── Cross-route reload from RunDetailPage ────────────────────────────────
  // RunDetailPage (run inspector) navigates here with brief + history entry in
  // location.state; we hydrate the form and prepend the historical output to
  // outputHistory so the user sees both inputs and outputs in one place.
  // Clearing state via navigate(replace) prevents re-import on page refresh.
  useEffect(() => {
    const preloaded = location.state?.preloadedBrief;
    if (!preloaded) return;
    const formState = briefEnvelopeToFormState(preloaded);
    const importedEntry = location.state.preloadedHistoryEntry;
    const prevHistory = stateRef.current.outputHistory || [];
    dispatch({ type: 'SET_BATCH', payload: {
      ...formState,
      wizardStep: 1,
      error: null,
      outputHistory: importedEntry ? [importedEntry, ...prevHistory] : prevHistory,
    }});
    // Clear navigation state so refresh doesn't re-import
    navigate(location.pathname, { replace: true, state: null });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // ── Keyboard shortcut Ctrl+Enter ──────────────────────────────────────────
  useEffect(() => {
    const onKey = (e) => { if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') guardedGenerate(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [guardedGenerate]);

  return (
    <div style={{ minHeight: '100vh', background: t.bg, color: t.text, fontFamily: "'DM Sans', sans-serif", zoom: 1.1 }}>
      <ErrorModal message={state.error} onClose={dismissError} t={t} />
      {pendingAction && <LeaveGuardModal type={pendingAction.type} onConfirm={confirmAction} onCancel={cancelAction} t={t} />}
      {examplesOpen && state.tenant && (
        <ExamplesModal
          tenant={state.tenant}
          onSelect={handleLoadFromExample}
          onClose={closeExamples}
          t={t}
          color={c}
        />
      )}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px clamp(16px, 4vw, 48px)' }}>

        {/* ── Wizard nav ── */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
          {steps.map((label, i) => {
            const n = i + 1;
            const active = (wizardStep || 1) === n;
            return (
              <button
                key={n}
                onClick={() => dispatch({ type: 'SET_KEY', key: 'wizardStep', value: n })}
                style={{ flex: 1, padding: '10px 8px', borderRadius: '10px', border: active ? `2px solid ${c}` : `1px solid ${t.border}`, background: active ? `${c}15` : t.surface, color: active ? c : t.textMuted, fontWeight: active ? 700 : 400, fontSize: '13px', cursor: 'pointer', transition: 'all 0.2s' }}
              >
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '11px', opacity: 0.7 }}>{n}.</span> {label}
              </button>
            );
          })}
        </div>

        {/* ── Step 1: Genera ── */}
        {(wizardStep || 1) === 1 && (
          <>
            {/* Crea Contenuto loading → full stepper */}
            {state.isLoading && state.pipelineProgress ? (
              <Step2Generate
                progress={state.pipelineProgress}
                color={c}
                w={w}
                t={t}
                onCancel={cancelGeneration}
              />
            ) : state.suggestProgress ? (
              <>
                {/* Suggerisci loading → stepper above the form */}
                <Step2Generate
                  progress={state.suggestProgress}
                  color={c}
                  w={w}
                  t={t}
                />
                {/* Keep form visible below stepper (greyed out) */}
                <div style={{ opacity: 0.4, pointerEvents: 'none', marginTop: '16px' }}>
                  <Step1Setup
                    state={state}
                    dispatch={dispatch}
                    onSuggest={handleSuggest}
                    color={c}
                    w={w}
                    t={t}
                    personaOptions={personaOptions}
                    objectiveOptions={objectiveOptions}
                  />
                </div>
              </>
            ) : (
              <>
                <Step1Setup
                  state={state}
                  dispatch={dispatch}
                  onSuggest={handleSuggest}
                  color={c}
                  w={w}
                  t={t}
                  personaOptions={personaOptions}
                  objectiveOptions={objectiveOptions}
                />
                <button
                  onClick={guardedGenerate}
                  disabled={state.isLoading || !state.taskText || state.taskText.trim().length < 10}
                  style={{
                    width: '100%', marginTop: '8px', padding: '16px', borderRadius: '12px',
                    background: `linear-gradient(135deg, ${c}, ${c}CC)`, border: 'none',
                    color: '#fff', fontSize: '16px', fontWeight: 700,
                    cursor: state.taskText?.trim().length >= 10 ? 'pointer' : 'not-allowed',
                    opacity: (!state.taskText || state.taskText.trim().length < 10) ? 0.5 : 1,
                    transition: 'all 0.2s',
                  }}
                >
                  ⚡ Crea Contenuto
                </button>
              </>
            )}
          </>
        )}

        {/* ── Step 2: Output ── */}
        {wizardStep === 2 && (
          <Step3History
            state={state}
            onRegenerate={regenerateFromEntry}
            onConfirm={confirmOutput}
            onDelete={deleteEntry}
            onCopy={copy}
            onGetText={getOutputText}
            onGetHtml={getBlogHtml}
            onDownload={handleDownload}
            renderEntry={(entry) => renderResultEntry(entry, rendererProps)}
            color={c}
            w={w}
            t={t}
          />
        )}

        {/* ── Step 3: Anteprima ── */}
        {wizardStep === 3 && (
          <Step4Publish
            state={state}
            onExport={exportEntry}
            renderEntry={(entry) => renderResultEntry(entry, rendererProps)}
            color={c}
            w={w}
            t={t}
          />
        )}

      </div>
    </div>
  );
};

export default EscContentCreatorPro;
